let apiUrl;
apiUrl = "https://bus-seats-reservation-api.herokuapp.com/api";
// if (process.env.NODE_ENV === "development") {
// } else {
//   apiUrl = "https://bus-seat-reservation-api.herokuapp.com/api";
// }

export default apiUrl;
